import { useEffect } from 'react';
import { hideTransformControl, ScanSelectionPopover } from '@viewer3D/components';
import { useAppDispatch } from '@core/redux/hooks';
import { viewer3dActions } from '@viewer3D/redux';
import { Canvas as ThreeCanvas } from '@react-three/fiber';
import * as THREE from 'three';
import { styled } from '@mui/material';
import { setSelectedPhoto } from '@photos/components/PhotosInViewport/state';
import { useParams } from 'react-router-dom';
import { disposeMaterialCache } from '@viewer3D/helper';
import { setMaxAnisotropy } from '@viewer3D/components/Map/Tile/hooks/tileTextureCache';
import { MapLayers } from './MapLayers';
import { useScansInScope } from './menu/ScanOrganization';
import { useScanFilters } from './hooks';
import { setSelectedPointIds, setSelectedSplineElements } from './menu/ElementOrganization/state';

const CanvasContainer = styled('div')(({ theme }) => ({
  position: 'fixed',
  overflow: 'hidden',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  background: theme.palette.grey[100],
  pointerEvents: 'auto',
}));

export const ProjectCanvas = () => {
  const dispatch = useAppDispatch();
  const scans = useScansInScope();
  const { projectId } = useParams();
  const { viewport, dateRange } = useScanFilters();

  useEffect(() => {
    return () => {
      disposeMaterialCache();
    };
  }, []);

  return (
    <CanvasContainer>
      <ThreeCanvas
        id="viewer3d"
        flat
        orthographic
        frameloop="demand"
        onCreated={({ gl }) => {
          gl.toneMapping = THREE.NoToneMapping;
          gl.outputColorSpace = THREE.SRGBColorSpace;
          setMaxAnisotropy(gl.capabilities.getMaxAnisotropy());
        }}
        onPointerMissed={(e) => {
          if (e.ctrlKey || e.button === 2) {
            // user pans camera, don't deselect stuff
            return;
          }
          dispatch(viewer3dActions.clearSelection());
          setSelectedPhoto(null);
          setSelectedSplineElements([]);
          setSelectedPointIds([]);
          hideTransformControl();
        }}
        camera={{ near: -10000, far: 10000 }}
      >
        {/* TODO unfortunately we have to pass the parameters to the MapLayers component explicitly because the
              react-router Context doesn't get passed to react-three-fiber Canvas, which has an own virtual DOM.
        */}
        <MapLayers
          scans={scans}
          viewport={viewport}
          dateRange={dateRange}
          projectId={projectId ?? ''}
        />
      </ThreeCanvas>
      <ScanSelectionPopover />
    </CanvasContainer>
  );
};
